module.exports = __webpack_public_path__ + "a755a8394d511ceebce42fd5539e49a0.MP3";